/*
 *  Document   : exa_helpers.js
 *  Author     : Exapoint
 *  Description: Various jQuery plugins inits as well as custom helpers
 *
 */

// Import global dependencies

// Import required modules
import './exa_modules/candidate-professions';
import AdministratorConsultants from "./exa_modules/administrator_consultants";
import AdministratorLanguagebyzip from "./exa_modules/administrator_languagebyzip";
import AdministratorConsultantsEdit from "./exa_modules/administrator-consultants-edit";
import CandidateProfessions from "./exa_modules/candidate-professions";
import CandidateEdit from "./exa_modules/candidate-edit";
import CandidateAdd from "./exa_modules/candidate-add";
import CandidateMissionIndex from "./exa_modules/candidate-mission-index";
import CandidateMissionBasicShow from "./exa_modules/candidate-mission-basic-show";
import CandidateRateMission from "./exa_modules/candidate-rate-mission";
import ConsultantActivities from "./exa_modules/consultant-activities";
import ConsultantActivitiesRegistrations from "./exa_modules/consultant-activities-registrations";
import ConsultantActivitiesRegistrationsError from "./exa_modules/consultant-activities-registrations-error";
import ConsultantCandidates from "./exa_modules/consultant_candidates";
import ConsultantCandidatesEdit from "./exa_modules/consultant_candidates_edit";
import ConsultantClients from "./exa_modules/consultant-clients";
import ConsultantClientsEdit from "./exa_modules/consultant_clients_edit";
import ConsultantCompanies from "./exa_modules/consultant-companies";
import ConsultantCompaniesEdit from "./exa_modules/consultant-companies-edit";
import ConsultantMissionIndex from "./exa_modules/consultant-mission-index";
import ConsultantMissionAll from "./exa_modules/consultant-mission-all";
import ContactConfirm from "./exa_modules/contact-confirm";
import ConstultantAddCandidate from "./exa_modules/consultant-add-candidate";
import ClientRateMission from "./exa_modules/client-rate-mission";
import ClientEdit from "./exa_modules/client-edit";
import ClientCompanyData from "./exa_modules/client-company-data";
import ClientCompanyUsers from "./exa_modules/client-company-users";
import ClientMissionEdit from "./exa_modules/client-mission-edit";
import ClientMissionIndex from "./exa_modules/client-mission-index";
import UserPasswordChange from "./exa_modules/user-password-change";
import UserMobileChange from "./exa_modules/user-mobile-change";
import OperatorBox from "./exa_modules/operator_box";
import Register from "./exa_modules/register";
import VerifyMobile from "./exa_modules/verify-mobile";
import 'jquery-stickytabs';

// Helpers
export default class ExaHelpers {
    /*
     * Run helpers
     *
     */
    static run(helpers, options = {}) {
        // List of methods parent Helpers implemented
        let parentImplementation = [
            'core-bootstrap-tooltip', 'core-bootstrap-popover', 'core-bootstrap-tabs', 'core-bootstrap-custom-file-input',
            'core-toggle-class', 'core-scroll-to', 'core-year-copy', 'core-appear', 'core-ripple', 'print',
            'table-tools-sections', 'table-tools-checkable', 'magnific-popup', 'summernote', 'ckeditor', 'simplemde',
            'slick', 'datepicker', 'colorpicker', 'masked-inputs', 'select2', 'highlightjs', 'notify', 'easy-pie-chart',
            'maxlength', 'rangeslider', 'sparkline', 'validation', 'pw-strength', 'flatpickr'
        ];

        // List of custom and overriden helpers
        let helperList = {
            'administrator-consultants': () => new AdministratorConsultants(),
            'administrator-consultants-edit': () => new AdministratorConsultantsEdit(),
            'administrator-languagebyzip': () => new AdministratorLanguagebyzip(),
            'professions-edit': () => new CandidateProfessions(),
            'candidate-edit': () => new CandidateEdit(),
            'candidate-add': () => new CandidateAdd(),
            'candidate-mission-index': () => new CandidateMissionIndex(),
            'candidate-mission-basic-show': () => new CandidateMissionBasicShow(),
            'candidate-rate-mission': () => new CandidateRateMission(),
            'client-profile-edit': () => new ClientProfileEdit(),
            'consultant-activities': () => new ConsultantActivities(),
            'consultant-activities-registrations': () => new ConsultantActivitiesRegistrations(),
            'consultant-activities-registrations-error': () => new ConsultantActivitiesRegistrationsError(),
            'consultant-candidates': () => new ConsultantCandidates(),
            'consultant-candidates-edit': () => new ConsultantCandidatesEdit(),
            'consultant-clients': () => new ConsultantClients(),
            'consultant-clients-edit': () => new ConsultantClientsEdit(),
            'consultant-mission-index': () => new ConsultantMissionIndex(),
            'consultant-mission-all': () => new ConsultantMissionAll(),
            'contact-confirm': () => new ContactConfirm(),
            'consultant-add-candidate': () => new ConstultantAddCandidate(),
            'client-edit': () => new ClientEdit(),
            'client-company-data': () => new ClientCompanyData(),
            'client-company-users': () => new ClientCompanyUsers(),
            'client-mission-edit': () => new ClientMissionEdit(),
            'client-mission-index': () => new ClientMissionIndex(),
            'client-rate-mission': () => new ClientRateMission(),
            'consultant-companies': () => new ConsultantCompanies(),
            'consultant-companies-edit': () => new ConsultantCompaniesEdit(),
            'operator-box': () => new OperatorBox(),
            'user-password-change': () => new UserPasswordChange(),
            'user-mobile-change': () => new UserMobileChange(),
            'select2': () => this.select2(options),
            'sticky-tabs': () => this.stickyTabs(),
            'validation': () => this.validation(),
            'flatpickr': () => this.flatpickr(),
            'status-toggle': () => this.statusToggle(),
            'summernoteBySelector': () => this.summernoteBySelector(selector),
            'empty-links': () => this.emptyLinks(),
            'phone-validation': () => this.phoneValidation(),
            'rating': () => this.rating(),
            'register': () => new Register(),
            'client-side-logger': () => this.clientSideLogger(),
            'footer-info': () => this.footerInfo(),
            'extend-bootstrap-tabs': () => this.extendBootstrapTabs(),
            'verify-mobile': () => new VerifyMobile(),
        };

        /*if (typeof window.exaHelpersRan !== "undefined") {
            // Add default helpers to all pages
            ExaHelpers.emptyLinks();
            window.exaHelpersRan = true;
        }*/

        if (helpers instanceof Array) {
            for (let index in helpers) {
                if (helperList[helpers[index]]) {
                    helperList[helpers[index]](options);
                } else if (parentImplementation.indexOf(helpers[index]) !== -1) {
                    window.Dashmix.helpers(helpers, options);
                }
            }
        } else {
            if (helperList[helpers]) {
                helperList[helpers](options);
            } else if (parentImplementation.indexOf(helpers) !== -1) {
                window.Dashmix.helpers(helpers, options);
            }
        }
    }

    // Overridden
    static stickyTabs() {
        let $tabs = $('.nav-tabs');
        if (!window.location.hash) {
            $tabs.find('.nav-item:first-child a').tab('show');
        }

        let isInIframe;
        try {
            isInIframe = window.self !== window.top;
        } catch (e) {
            isInIframe = true;
        }
        if (!isInIframe) {
            $tabs.stickyTabs();
        } else {
            //TODO: Pull this into the view to avoid tab flash?
            $tabs.find('.nav-item a[href="' + window.location.hash + '"]').tab('show');
        }
    }

    // Overridden
    static select2(options) {
        // Init Select2 (with .js-select2 class)
        jQuery('.js-select2:not(.js-select2-enabled)').each((index, element) => {
            let el = jQuery(element);

            // Add .js-select2-enabled class to tag it as activated and init it
            el.addClass('js-select2-enabled').select2({
                language: Laravel.locale,
                placeholder: el.data('placeholder') || el.data('data-placeholder') || false,
                matcher: ExaHelpers.matcher,
                sorter: ExaHelpers.sorter,
                escapeMarkup: function (markup) { // Return as is, i.e. don''t escape HTML
                    return markup;
                }
            }).on('select2:select', function (e) {
                var id = e.params.data.id;
                var option = $(e.target).children('[value=' + id + ']');
                option.detach();
                $(e.target).append(option).change();
            });
        });
    }

    // Overridden
    static validation() {
        // Set default options for jQuery Validation plugin
        jQuery.validator.setDefaults({
            errorClass: 'invalid-feedback animated fadeIn',
            errorElement: 'div',
            errorPlacement: (error, el) => {
                jQuery(el).parents('.form-group').find('.form-control, .form-check-input, .custom-control-input').addClass('is-invalid');
                jQuery(el).parents('.form-group').append(error);
            },
            highlight: el => {
                jQuery(el).parents('.form-group').find('.is-invalid').removeClass('is-invalid').addClass('is-invalid');
            },
            success: el => {
                jQuery(el).parents('.form-group').find('.is-invalid').removeClass('is-invalid');
                jQuery(el).remove();
            }
        });

        jQuery.validator.addMethod("intlTelNumber", function (value, element) {
            return this.optional(element) || $(element).intlTelInput("isValidNumber");
        }, $.validator.messages.number);
    }

    static flatpickr() {
        // Init Flatpickr (with .js-flatpickr class)
        jQuery('.js-flatpickr:not(.js-flatpickr-enabled)').each((index, element) => {
            let el = jQuery(element);

            // Add .js-flatpickr-enabled class to tag it as activated
            el.addClass('js-flatpickr-enabled');

            // Init it
            flatpickr(el, {
                allowInput: el.data('allow-input') || false,
                locale: Laravel.locale,
                onClose: function (selectedDates, dateStr, instance) {
                    let $visibleInput = $(instance.element).parent().find('.input');
                    instance.setDate($visibleInput.val(), true, 'd.m.Y');
                },
                onReady: function (selectedDates, dateStr, instance) {
                    if (instance.isMobile) {
                        $(instance.mobileInput).attr('step', null);
                    }
                },
            });
        });
    }

    static extractFieldFromName(inputName) {
        let matches = inputName.match(/(\[(.*?)\])/g);
        if (matches) {
            for (var i = matches.length - 1; i >= 0; i--) {
                let str = matches[i].substring(1, matches[i].length - 1).trim();
                if (str !== "") {
                    return str;
                }
            }
        } else {
            return inputName;
        }
    }

    static applyInputValue($toInput, $fromInput) {
        if ($fromInput.length === 1) {
            $fromInput = $fromInput.first();
        }

        if ($toInput.prop('type') === "checkbox" || $fromInput.prop('type') === "checkbox") {
            let newValue = this.boolval($fromInput.prop('checked'));
            $toInput.val(newValue);
            $toInput.prop('checked', newValue);

            if (newValue) {
                $toInput.attr('checked', 'checked');
            } else {
                $toInput.removeAttr('checked');
            }

            let $parentTd = $toInput.parent('td');
            if ($parentTd.length !== 0 && $parentTd.find('.bool-button').length !== 0) {
                let $boolButton = $parentTd.find('.bool-button');
                if (newValue) {
                    $boolButton.find('.btn-success').show();
                    $boolButton.find('.btn-danger').hide();
                } else {
                    $boolButton.find('.btn-success').hide();
                    $boolButton.find('.btn-danger').show();
                }
            }
            return;
        }

        if ($toInput.prop('type') === "select-one" || $fromInput.prop('type') === "select-one") {
            let newValue = $fromInput.val();
            let newValueText = $fromInput.find("option:selected").text();

            // var $options = $fromInput.find('option').clone();
            // $('#secondSelectId').append($options)
            //TODO: Before setting value check if select has options
            if ($toInput.find("option").length === 0) {
                $toInput.append($fromInput.find('option').clone());
            }

            $toInput.val(newValue).change();
            $toInput.find('option').removeAttr('selected');
            $toInput.find('option[value="' + newValue + '"]').attr('selected', 'selected');

            if ($toInput.parent().find('.select-label').length !== 0) {
                $toInput.parent().find('.select-label').text(newValueText);
            }

            return;
        }

        if ($toInput.prop('type') === "text" || $fromInput.prop('type') === "text") {
            let newValue = $fromInput.val();

            $toInput.val(newValue).change();

            if ($toInput.parent().find('.select-label').length !== 0) {
                $toInput.parent().find('.select-label').text(newValue);
            }

            return;
        }

        if ($toInput.prop('type') === "hidden" || $fromInput.prop('type') === "hidden") {
            let newValue = $fromInput.val();

            if ($toInput.hasClass('summernote')) {
                $toInput.summernote('code', newValue);
            } else {
                $toInput.val(newValue).change();
            }

            return;
        }

        console.error('No matching type.');
    }

    static boolval(mixedVar) {
        if (mixedVar === false) {
            return false;
        }

        if (mixedVar === 0 || mixedVar === 0.0) {
            return false;
        }

        if (mixedVar === '' || mixedVar === '0') {
            return false;
        }

        if (mixedVar === 'on') {
            return true;
        }

        if (Array.isArray(mixedVar) && mixedVar.length === 0) {
            return false;
        }

        return !(mixedVar === null || mixedVar === undefined);
    }

    // Select2 matcher, sorter and fuzzy_match are taken and adapted from https://github.com/select2/select2/issues/4837
    static matcher(term, text) {
        if (term.term === undefined) {
            return text;
        }

        if (term.term.charAt(0).toLowerCase() !== text.text.charAt(0).toLowerCase()) {
            return null;
        }

        var match = ExaHelpers.fuzzy_match(term.term, text.text);
        if (match[0]) {
            var modifiedData = $.extend({}, text, true);
            modifiedData.text = match[2];

            return modifiedData;
        }
        return null;
    };

    static sorter(data) {
        return data.filter(function (item) {
            return !!item;
        }).sort((a, b) => b.score - a.score)
            .map(item => item);
    };

    /**
     *
     * @param pattern
     * @param str
     * @returns {[boolean,score,formatted]}
     */
    static fuzzy_match(pattern, str) {

        // Score consts
        var adjacency_bonus = 55;                // bonus for adjacent matches
        var separator_bonus = 10;               // bonus if match occurs after a separator
        var camel_bonus = 10;                   // bonus if match is uppercase and prev is lower
        var leading_letter_penalty = -3;        // penalty applied for every letter in str before the first match
        var max_leading_letter_penalty = -9;    // maximum penalty for leading letters
        var unmatched_letter_penalty = -1;      // penalty for every letter that doesn't matter

        // Loop variables
        var score = 0;
        var patternIdx = 0;
        var patternLength = pattern.length;
        var strIdx = 0;
        var strLength = str.length;
        var prevMatched = false;
        var prevLower = false;
        var prevSeparator = true;       // true so if first letter match gets separator bonus

        // Use "best" matched letter if multiple string letters match the pattern
        var bestLetter = null;
        var bestLower = null;
        var bestLetterIdx = null;
        var bestLetterScore = 0;

        var matchedIndices = [];

        // Loop over strings
        while (strIdx != strLength) {
            var patternChar = patternIdx != patternLength ? pattern.charAt(patternIdx) : null;
            var strChar = str.charAt(strIdx);

            var patternLower = patternChar != null ? patternChar.toLowerCase() : null;
            var strLower = strChar.toLowerCase();
            var strUpper = strChar.toUpperCase();

            var nextMatch = patternChar && patternLower == strLower;
            var rematch = bestLetter && bestLower == strLower;

            var advanced = nextMatch && bestLetter;
            var patternRepeat = bestLetter && patternChar && bestLower == patternLower;
            if (advanced || patternRepeat) {
                score += bestLetterScore;
                matchedIndices.push(bestLetterIdx);
                bestLetter = null;
                bestLower = null;
                bestLetterIdx = null;
                bestLetterScore = 0;
            }

            if (nextMatch || rematch) {
                var newScore = 0;

                // Apply penalty for each letter before the first pattern match
                // Note: std::max because penalties are negative values. So max is smallest penalty.
                if (patternIdx == 0) {
                    var penalty = Math.max(strIdx * leading_letter_penalty, max_leading_letter_penalty);
                    score += penalty;
                }

                // Apply bonus for consecutive bonuses
                if (prevMatched)
                    newScore += adjacency_bonus;

                // Apply bonus for matches after a separator
                if (prevSeparator)
                    newScore += separator_bonus;

                // Apply bonus across camel case boundaries. Includes "clever" isLetter check.
                if (prevLower && strChar == strUpper && strLower != strUpper)
                    newScore += camel_bonus;

                // Update patter index IFF the next pattern letter was matched
                if (nextMatch)
                    ++patternIdx;

                // Update best letter in str which may be for a "next" letter or a "rematch"
                if (newScore >= bestLetterScore) {

                    // Apply penalty for now skipped letter
                    if (bestLetter != null)
                        score += unmatched_letter_penalty;

                    bestLetter = strChar;
                    bestLower = bestLetter.toLowerCase();
                    bestLetterIdx = strIdx;
                    bestLetterScore = newScore;
                }

                prevMatched = true;
            } else {
                // Append unmatch characters
                formattedStr += strChar;

                score += unmatched_letter_penalty;
                prevMatched = false;
            }

            // Includes "clever" isLetter check.
            prevLower = strChar == strLower && strLower != strUpper;
            prevSeparator = strChar == '_' || strChar == ' ';

            ++strIdx;
        }

        // Apply score for last match
        if (bestLetter) {
            score += bestLetterScore;
            matchedIndices.push(bestLetterIdx);
        }

        // Finish out formatted string after last pattern matched
        // Build formated string based on matched letters
        var formattedStr = "";
        var lastIdx = 0;
        for (var i = 0; i < matchedIndices.length; ++i) {
            var idx = matchedIndices[i];
            formattedStr += str.substr(lastIdx, idx - lastIdx) + "<b>" + str.charAt(idx) + "</b>";
            lastIdx = idx + 1;
        }
        formattedStr += str.substr(lastIdx, str.length - lastIdx);

        var matched = patternIdx == patternLength;
        return [matched, score, formattedStr];
    };

    // Load js file and run callback on load
    static addScript(filepath, callback) {
        if (filepath) {
            var fileref = document.createElement('script');
            var done = false;
            var head = document.getElementsByTagName("head")[0];

            fileref.onload = fileref.onreadystatechange = function () {
                if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
                    done = true;

                    callback();

                    // Handle memory leak in IE
                    fileref.onload = fileref.onreadystatechange = null;
                    if (head && fileref.parentNode) {
                        head.removeChild(fileref);
                    }
                }
            };

            fileref.setAttribute("type", "text/javascript");
            fileref.setAttribute("src", filepath);

            head.appendChild(fileref);
        }
    }

    static statusToggle() {
        $('.status-checkbox [name*="status_id"]').each((index, element) => {
            let $el = $(element);
            $el.on('change', function (e) {
                if ($el.prop('checked')) {
                    setTimeout(function () {
                        $el.parent().find('.verified').fadeIn();
                        $el.parent().find('.unverified').hide();
                    }, 300);
                } else {
                    setTimeout(function () {
                        $el.parent().find('.verified').hide();
                        $el.parent().find('.unverified').fadeIn();
                    }, 300);
                }
            })
        });
    }

    static summernoteBySelector(selector) {
        $(selector).each((index, element) => {
            let el = jQuery(element);

            // Add .js-summernote-enabled class to tag it as activated and init it
            el.addClass('js-summernote-enabled').summernote({
                height: el.data('height') || 350,
                minHeight: el.data('min-height') || null,
                maxHeight: el.data('max-height') || null,
                toolbar: [
                    ['font', ['bold', 'italic', 'underline', 'clear',]],
                    ['para', ['ol', 'ul']],
                    ['view', ['undo', 'redo', 'fullscreen', 'codeview', 'help']]
                ],
                // See: http://summernote.org/deep-dive/
                callbacks: {
                    onChange: function (contents, $editable) {
                        el.val(el.summernote('isEmpty') ? "" : contents);
                    }
                }
            });
        });
    }

    static emptyLinks() {
        $('body').on('click', 'a.empty-link', function (e) {
            e.preventDefault();
        })
    }

    static loadIframeInModal(e) {
        let $modal = $(e.target);
        let $target = $(e.relatedTarget).first();
        let iframeId = '_' + Math.random().toString(36).substr(2, 9);

        $modal.find('.modal-content').html(`<iframe src="${$target.data('remote')}?minimal_layout=true"
                onload="adaptIframe()" id="${iframeId}"></iframe>`);
        let $iframe = $('#' + iframeId);
        $iframe.hide();

        window.adaptIframe = function () {
            if (window.frames.length) {
                window.frames[window.frames.length - 1].onerror = window.onerror;
            }
// html { overflow-x: hidden; }
            $iframe.contents().find("head")
                .append($(`
                    <style type='text/css'>
                        
                        #main-container { margin-bottom: 12px; }
                        #page-container.page-header-fixed #main-container {
                            padding-top: 0;
                        }
                        #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                            display:none !important;
                        }
                        #page-container.sidebar-o {
                            padding-left: 0;
                        }
                        .main-container {
                            left: 0px !important;
                            top: 0px !important;
                            padding: 0 60px !important;
                            margin-left: 0px !important;
                            margin-top: 0px !important;
                            margin-bottom: 26px;
                            max-width: 99% !important;
                        }
                        .layout-container.view {
                            max-width: 100% !important
                        }
                        @media(max-width:992px) { .main-container { padding: 0 !important; } }
                     </style>`));
            $iframe.show();
            $iframe.height('67.5vh');
            $iframe.css('border', 0);
        };
    }

    static isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    static formatDateWithLocale(d) {
        return d.toLocaleDateString('de-CH',
            {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            }
        );
    }

    static formatDateTimeWithLocale(d, labelInBetween) {
        return d.toLocaleDateString('de-CH',
            {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            }
        ) + labelInBetween + d.toLocaleTimeString('de-CH');
    }

    static ratingToIcons(rating) {
        let rounded = Math.round(rating * 2) / 2;
        let starString = '';
        let maxStars = 5;
        let starCount = 0;

        for (rounded; rounded >= 1; rounded--) {
            starString += `<i class="fa fa-star text-primary"></i>`;
            starCount++;
        }
        if (rounded > 0) {
            starString += `<i class="fa fa-star-half-alt text-primary"></i>`;
            starCount++;
        }
        for (starCount; starCount < maxStars; starCount++) {
            starString += `<i class="far fa-star text-primary"></i>`;
        }
        return `<div class="star-rating-container">${starString}</div>`;
    }

    static initCrudAjaxModal($modal, options) {
        $modal.on('show.bs.modal', function (e) {
            let $modal = $(e.target);
            let $target = $(e.relatedTarget).first();
            if ($target.length === 0) {
                console.error('Error! Cant find related target.');
                return;
            }

            let isExistingRecord = false;
            let $inputs = $target.closest('tr').find('[name]');
            $inputs.each(function (i, el) {
                let $el = $(el);
                let fieldName = ExaHelpers.extractFieldFromName(el.name);
                let $input = $modal.find(`[name="${fieldName}"]`);

                if ($input && $input.length !== 0) {
                    ExaHelpers.applyInputValue($input, $el);
                    $input.data('originalName', el.name);
                }

                if (fieldName === 'id') {
                    isExistingRecord = $input.val() !== "";
                }
            });

            if (options.updateTitle) {
                $modal.find('.block-title').text($target.closest('tr').find('th:first').text().trim());
            }

            if (!isExistingRecord) {
                $modal.find('.btn-delete').hide();
            } else {
                $modal.find('.btn-delete').show();
            }

            // $modal[0].dispatchEvent(new CustomEvent('inputsLoaded', {detail: $inputs}));
        });

        // Every time modal hides
        $modal.on('hide.bs.modal', function (e) {
        });

        // When button confirm is clicked
        $modal.find('.btn-confirm').unbind().on('click', function (e) {
            let noteId = options.$form.find('[name="id"]').val();
            if (noteId !== "") {
                noteId = '/' + noteId;
            }

            // $modal[0].dispatchEvent(new CustomEvent('requestSent'));
            $.ajax({
                type: 'POST',
                url: options.ajaxUrl + noteId,
                data: options.$form.serialize(),
            }).then((response) => {
                // $modal[0].dispatchEvent(new CustomEvent('responseReceived', {detail: response}));
                options.datatablesApi.ajax.reload();
            });
        });

        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        $(".js-swal-confirm").on("click", (function (n) {
            e.fire({
                title: jsVars.confirm_delete_title,
                text: jsVars.confirm_delete_text,
                icon: "warning",
                showCancelButton: !0,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-outline-primary m-1"},
                confirmButtonText: jsVars.confirm_button_text,
                html: !1,
                preConfirm: function (e) {
                    // When button delete is clicked
                    let noteId = options.$form.find('[name="id"]').val();
                    if (noteId !== "") {
                        noteId = '/' + noteId;
                    }

                    return $.ajax({
                        type: 'DELETE',
                        url: options.ajaxUrl + noteId,
                        data: options.$form.serialize(),
                    }).then((response) => {
                        options.datatablesApi.ajax.reload();
                    }).catch(error => {
                        Swal.showValidationMessage(
                            jsVars.confirm_delete_error
                        )
                    });
                }
            }).then((function (n) {
                n.value ?
                    e.fire(jsVars.confirm_delete_deleted_title, jsVars.confirm_delete_deleted_text, "success") && $modal.modal('hide') :
                    "cancel" === n.dismiss
            }))
        }));
    }

    static bindCandidateInfoModal($modal) {
        $modal.on('show.bs.modal', function (e) {
            let $modal = $(e.target);
            let $target = $(e.relatedTarget).closest('[data-remote]').first();
            let iframeId = '_' + Math.random().toString(36).substr(2, 9);
            let height = $target.data('height') || '85vh';
            let width = $target.data('width') || 'inherit';

            $modal.find('.modal-content').html(`<iframe src="${$target.data('remote').replace(Laravel.app_url.replace('/app', ''), '')}" onload="adaptIframe()" id="${iframeId}"></iframe>`);
            $modal.find('.modal-dialog').width(width);
            let $iframe = $('#' + iframeId);
            $iframe.hide();

            window.adaptIframe = function () {
                if (window.frames.length) {
                    window.frames[window.frames.length - 1].onerror = window.onerror;
                }

                //html { overflow-x: hidden; }
                $iframe.contents().find("head")
                    .append($(`
                    <style type='text/css'>
                        
                        #main-container { margin-bottom: 12px; }
                        #page-container.page-header-fixed #main-container {
                            padding-top: 0;
                        }
                        #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                            display:none !important;
                        }
                        #page-container.sidebar-o {
                            padding-left: 0;
                        }
                        .main-container {
                            left: 0px !important;
                            top: 0px !important;
                            padding: 0 60px !important;
                            margin-left: 0px !important;
                            margin-top: 0px !important;
                            margin-bottom: 26px;
                            max-width: 99% !important;
                        }
                        .layout-container.view {
                            max-width: 100% !important
                        }
                        @media(max-width:992px) { .main-container { padding: 0 !important; } }
                     </style>`));
                $iframe.show();

                if (height === 'auto') {
                    $iframe.height($iframe.contents().find('#main-container .content').outerHeight() + 25);
                } else {
                    $iframe.height(height);
                }
                $iframe.css('border', 0);

                // Setting it to iframe contents height is too low
                // $iframe.height($iframe.contents().height());
            };
        });
    }

    static updateUrlParameter(uri, key, value) {
        // remove the hash part before operating on the uri
        var i = uri.indexOf('#');
        var hash = i === -1 ? '' : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);

        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";

        if (!value) {
            // remove key-value pair if value is empty
            uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
            if (uri.slice(-1) === '?') {
                uri = uri.slice(0, -1);
            }
            // replace first occurrence of & by ? if no ? is present
            if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
        } else if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            uri = uri + separator + key + "=" + value;
        }
        return uri + hash;
    }

    static rating() {
        // Set Default options
        jQuery.fn.raty.defaults.starType = 'i';

        // Init Raty on .js-rating class
        jQuery('.js-rating').each((index, element) => {
            let el = jQuery(element);

            el.raty({
                score: el.data('score') || 0,
                scoreName: el.data('score-name') || false,
                number: el.data('number') || 5,
                cancel: el.data('cancel') || false,
                target: el.data('target') || false,
                targetScore: el.data('target-score') || false,
                precision: el.data('precision') || false,
                cancelOff: el.data('cancel-off') || 'fa fa-fw fa-times-circle text-danger',
                cancelOn: el.data('cancel-on') || 'fa fa-fw fa-times-circle',
                starHalf: el.data('star-half') || 'fa fa-fw fa-star-half text-primary',
                starOff: el.data('star-off') || 'fa fa-fw fa-star text-muted',
                starOn: el.data('star-on') || 'fa fa-fw fa-star text-primary',
                click: function (score, evt) {
                }
            });
        });
    }

    static phoneValidation() {
        $('.phonemask').each(function (index, value) {

            let $el = $(value);
            let numberType = 'MOBILE';
            if ($el.prop('name').indexOf('mobile') === -1) {
                numberType = 'FIXED_LINE';
            }
            let $new = $el.clone();
            $new.prop('hidden', true);
            $el.after($new);
            $el.prop('name', $el.prop('name') + '_intl');
            $el.prop('id', $el.prop('id') + '_intl');

            $el.on('change countrychange', function (e) {
                let selectedCountryCode = $el.intlTelInput("getSelectedCountryData");
                if (typeof selectedCountryCode.dialCode !== "undefined") {
                    let countryCode = `+${selectedCountryCode.dialCode}`;
                    $new.val(countryCode + $el.intlTelInput("getNumber").replace(countryCode, ''));
                } else {
                    $new.val($el.intlTelInput("getNumber"));
                }
            })

            $el.intlTelInput({
                localizedCountries: {'de': 'Deutschland'},
                preferredCountries: [
                    'ch', 'fr', 'it', 'de'
                ],
                onlyCountries: ['al', 'ad', 'at', 'by', 'be', 'ba', 'bg', 'hr', 'cz', 'dk', 'ee', 'fo', 'fi', 'fr',
                    'de', 'gi', 'gr', 'va', 'hu', 'is', 'ie', 'it', 'lv', 'li', 'lt', 'lu', 'mk', 'mt', 'md', 'mc',
                    'me', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sm', 'rs', 'sk', 'si', 'es', 'se', 'ch', 'ua', 'gb'
                ],
                initialCountry: 'ch',
                placeholderNumberType: numberType,
                utilsScript: Laravel.app_url + "/js/plugins/intl-tel-input/build/js/utils.js",
            });
        });
    }

    static submitAjaxFormWithButtons($form) {
        if ($form.data('validator') && !$form.valid()) {
            // Form has validator and is invalid
            return console.log('Form is invalid');
        }

        return $.ajax({
            type: 'POST',
            url: $form.prop('action'),
            data: $form.serialize(),
        }).then((response, textStatus, jqXHR) => {
            try {
                new URL(response);
                ExaHelpers.redirectWindow(response);
            } catch (_) {
                alert(Laravel.jsError);
                console.error("No url returned", response);
            }
        }).fail((e, textStatus, errorThrown) => {
            console.error(e);
        });
    }

    static redirectWindow(redirectToRoute) {
        if (parent && window.location !== window.parent.location) {
            parent.postMessage({
                type: 'iframe.redirect_requested',
                redirectTo: redirectToRoute
            }, "*");
        } else {
            window.location = redirectToRoute;
        }
    }

    static clientSideLogger() {
        if (window.clientSideLogger) {
            return;
        }
        window.clientSideLogger = true;

        try {
            window.onerror = function (err, url, line, column, errorObj) {
                //api url
                var apiUrl = Laravel.app_url + '/client-side-log';

                //suppress browser error messages
                var suppressErrors = false;
                console.log(err);

                $.ajax({
                    url: apiUrl,
                    type: 'POST',
                    data: {
                        errorMsg: err,
                        stack: typeof errorObj !== "undefined" ? errorObj.stack : '',
                        errorLine: line,
                        column: column,
                        queryString: document.location.search,
                        url: document.location.pathname,
                        referrer: document.referrer,
                        userAgent: navigator.userAgent,
                        _token: Laravel.csrfToken
                    }
                });

                return suppressErrors;
            };
        } catch (e) {
        }
    }

    static footerInfo() {
        this.bindCandidateInfoModal($('#footer-info-modal'));
    }

    static extendBootstrapTabs() {
        jQuery('[data-toggle="tabs"] a.nav-link').each((_, element) => {
            $(element).on('shown.bs.tab', function (e) {
                // Recalculate responsive on tab change
                $.each($('#' + e.target.href.split("#")[1]).find('.dataTable'), function (_i, value) {
                    let dt = $(value).DataTable();
                    if (typeof dt != "undefined" && dt && dt.responsive) {
                        dt.responsive.recalc();
                    }
                })
            });
        })
    }
}
